import {
  List, Datagrid, TextField, EmailField, DateField, BooleanField, EditButton, Edit, SimpleForm,
  TextInput, BooleanInput, ExportButton, TopToolbar, FilterButton,
} from 'react-admin';
import { Stack } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';

const filters = [
  <TextInput key="q" source="q" label="Search name/subject" alwaysOn />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const ContactList = () => (
  <List
    sort={{ field: 'createdAt', order: 'DESC' }}
    filters={filters}
    actions={<ListActions />}
    perPage={25}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <DateField source="createdAt" label="Received" showTime />
      <TextField source="name" />
      <EmailField source="email" />
      <TextField source="subject" />
      <BooleanField source="isRead" label="Read" />
      <EditButton />
    </Datagrid>
  </List>
);

const ContactEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm>
      <Stack spacing={2} sx={{ maxWidth: 720 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextInput source="name" disabled fullWidth />
          <TextInput source="email" disabled fullWidth />
          <TextInput source="phone" disabled />
        </Stack>
        <TextInput source="subject" disabled fullWidth />
        <TextInput source="message" multiline minRows={6} fullWidth disabled />
        <BooleanInput source="isRead" label="Mark as read" />
      </Stack>
    </SimpleForm>
  </Edit>
);

export default {
  list: ContactList,
  edit: ContactEdit,
  icon: MailIcon,
  options: { label: 'Contact messages' },
  recordRepresentation: (r) => `${r.name} — ${r.subject || '(no subject)'}`,
};
